module.exports = __webpack_public_path__ + "img/Journalism08.1602cee3.png";